/**
 * Which columns render in the tabular monospace face.
 *
 * Decided by column id, because that is the one thing every table
 * shares — dates, identifiers and codes all read better with aligned
 * digits, and a column def does not have to opt in.
 *
 * Dates come in four naming families across the dashboard's tables:
 * `…Date` (orderDate, dateOfBirth), `…Timestamp` (createdTimestamp,
 * claimGeneratedTimestamp), a camelCase `…At` (startedAt, completedAt
 * on program journeys) and the bare `dos` / `…Generated` of the claims
 * tables. Only the first was recognised until 2026-09-09, which is why
 * the same date looked monospace on Assessments and proportional on
 * Programs. All four are covered now.
 *
 * The `At` test is case-sensitive on purpose: a camelCase boundary
 * (`startedAt`), never a lowercase `at` inside another word.
 */
export const isMonoColumnId = id => {
  if (!id) return false;
  const lower = id.toLowerCase();
  return (
    lower.includes('date') ||
    lower.includes('timestamp') ||
    lower.includes('generated') ||
    lower === 'dos' ||
    /[a-z0-9]At$/.test(id) ||
    lower.includes('birth') ||
    lower.includes('mrn') ||
    lower.includes('identifier') ||
    lower.includes('customid') ||
    lower.includes('uuid') ||
    lower.includes('cpt') ||
    lower.includes('icd') ||
    lower === 'code' ||
    lower.endsWith('code')
  );
};
